import React from "react";
import { GolfHeaderContainer } from "../organisms/golfHeaderContainer";
import GolfInputContainer from "../organisms/golfInputContainer";
import { SubHeader } from '../molecules/subHeader';
import SubHeader2 from '../../resources/image/subHeader2.png';
import GolfReservationPopupContainer from "../organisms/golfReservationPopupContainer";
import { connect } from "react-redux";

class GolfInputTemplate extends React.Component {
  constructor(props) {
      super(props);
      this.state = { 
        reserveChangeFlg : false
      };
  };
  componentDidMount() {
    if(this.props.changeReserveNo !== '' && this.props.changeReserveNo !== undefined && this.props.changeReserveNo !== null){
      this.setState({reserveChangeFlg:true});
    }
  }
  render() {
    
    return (
      <div>
        <GolfHeaderContainer 
          Label categoryLabel1={"利用者入力"} 
          categoryLabel2={"USER INPUT"} 
          path={this.state.reserveChangeFlg ? "/reserve/golf/changeStartTime" : "/reserve/golf/startTime"}
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
          />
        {!this.state.reserveChangeFlg ? 
          <SubHeader SubImage={SubHeader2} />
          :
          null
        }
        <GolfReservationPopupContainer
            state={this.props.state}
            onClickClosePopupWindow={this.props.onClickClosePopupWindow}
        />
        <GolfInputContainer 
          reserveType={this.state.reserveChangeFlg ? "change" : "reserve"}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
      changeReserveNo:state.changeReserveNo,
  };
};
const mapToDispatchToProps = (dispatch) => {
  return {
  };
}
export default connect(mapStateToProps, mapToDispatchToProps)(GolfInputTemplate);
// export default GolfInputTemplate;
